import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { InputTextareaModule } from 'primeng/inputtextarea';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextareaModule,
    CommonModule,
    TranslateModule,
  ],
})
export class TextareaComponent extends CommonBaseComponent {
  @Input() maxLength: number = 500;

  currentLength: number = 0;
  constructor() {
    super();
  }

  ngOnInit(): void {
    this.currentLength = this.form.controls[this.item.key].value?.length;

    this.form.controls[this.item.key].valueChanges.subscribe((val: string) => {
      this.currentLength = val?.length || 0;
    });

    if (this.maxLength > 500 || !this.maxLength) this.maxLength = 500;
  }
}
